import "./options.scss";

import React from "react";
import { connect } from "react-redux";

import Location from "./Location/Location";
import UploadedBy from "./UploadedBy/UploadedBy";
import Workstream from "./Workstream/Workstream";
import Task from "./Task/Task";
import UploadDate from "./UploadDate/UploadDate";
import Comment from "./Comment/Comment";

import Action from "./Action/Action";
import Collaborator from "./Collaborator/Collaborator";
import DateModified from "./DateModified/DateModified";
@connect(store => {
    return {
        files: store.files,
        loggedUser: store.loggedUser
    };
})

class Options extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { files, dispatch, projectId } = this.props;
        const isSearchActive = Object.keys(files.filters.options).filter(k => k !== "uploadedDate" ? (
            (k !== "name" && files.filters.options[k].value) || k === "name" && files.filters.options[k]
        ) : (
            (files.filters.options[k].from.value || files.filters.options[k].to.value)
        ));

        const handleReset = () => {
            if(isSearchActive.length > 0){
                dispatch({ type: "UPDATE_FILES_FILTERS_RESET" });
                dispatch({ type: "UPDATE_FILES_FILTERS_UPDATED", boolean: true });
                if(this.props.onCancel){
                    this.props.onCancel()
                }
            }
          
        }

        const handleCancel = () => {
            if(!files.filters.isUpdated) {
                handleReset();
            }

            if(this.props.onClose) {
                this.props.onClose();
            }
        }

        return (
            <div class="advancedSearchContainer">
                <div class="searchOptions">
                    <Location />
                    {files.filters.options.location.value  === 'activities' ? 
                        <div>
                            <Action />
                            <Collaborator projectId={projectId}/>
                            <DateModified />
                        </div>
                         : 
                        <div>
                            <UploadedBy projectId={projectId} />
                            <UploadDate />
                            <Workstream projectId={projectId} />
                            <Task projectId={projectId} />
                            <Comment />
                        </div>
                    }
                </div>
                <div class="searchButtons">
                    <button class="btnCancel" onClick={handleCancel}>Cancel</button>
                    <div class="otherButtons">
                        <button onClick={handleReset} class={`btnReset ${isSearchActive.length > 0 ? "active" : ""}`}>Reset</button>
                        <button onClick={this.props.onSave} class={`btnSearch ${isSearchActive.length > 0 ? "active" : ""}`}>Search</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Options;